export default "__VITE_ASSET__2hnjEWAV__"